export default class FormButtonHandler
{
    constructor(root) {
        this.root = root;
        this.submitElementSelector = 'input[type=submit], button:not([type=reset], [type=button])';
    }

    attach() {
        $(this.root).on('click', (e) => this.onClick(e));
    }

    onClick(e) {
        var $submitElement = $(this.findValidSubmitElement(e.target));

        if (
            $submitElement.length > 0
            && !$submitElement.prop('disabled') // ignore already disabled elements
            && $submitElement.prop('form') // ignore elements outside of forms
            && $submitElement.parents('*[data-role="container"]').length === 0 // ignore ajaxify forms
            && !$submitElement.hasClass('form-button-handler-hidden-submit')
        ) {
            // disable the element
            $submitElement
                .attr('disabled', true)
                .addClass('imatic-view-ajaxify-busy')
            ;

            // re-submit the form using a hidden button
            var $hiddenSubmit = $(Imatic.View.Html.expand(
                '<input class="form-button-handler-hidden-submit" style="display: none;" type="submit" name="{{name}}" value="{{value}}">',
                {name: $submitElement.attr('name') || '', value: $submitElement.attr('value') || ''}
            )).insertAfter($submitElement);

            $hiddenSubmit.click();

            return false;
        }
    }

    isValidSubmitElement(element) {
        return $(element).is(this.submitElementSelector);
    }

    findValidSubmitElement(element) {
        var valid;

        while(!(valid = this.isValidSubmitElement(element))) {
            if (element.parentNode && 1 === element.parentNode.nodeType) {
                element = element.parentNode;
            } else {
                break;
            }
        }

        return valid ? element : null;
    }
}
